module.exports = __webpack_public_path__ + "img/hyy.8b73c276.png";